module.exports = __webpack_public_path__ + "img/img5_1.314167e7.jpeg";